import _regeneratorRuntime from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/regenerator/index.js";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(iterateFocusableElements);

export function iterateFocusableElements(container) {
  var options,
      _a,
      _b,
      strict,
      acceptFn,
      walker,
      nextNode,
      lastChild,
      _args = arguments;

  return _regeneratorRuntime.wrap(function iterateFocusableElements$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          strict = (_a = options.strict) !== null && _a !== void 0 ? _a : false;
          acceptFn = ((_b = options.onlyTabbable) !== null && _b !== void 0 ? _b : false) ? isTabbable : isFocusable;
          walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
            acceptNode: function acceptNode(node) {
              return node instanceof HTMLElement && acceptFn(node, strict) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
          });
          nextNode = null;

          if (!(!options.reverse && acceptFn(container, strict))) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return container;

        case 8:
          if (options.reverse) {
            lastChild = walker.lastChild();

            while (lastChild) {
              nextNode = lastChild;
              lastChild = walker.lastChild();
            }
          } else {
            nextNode = walker.firstChild();
          }

        case 9:
          if (!(nextNode instanceof HTMLElement)) {
            _context.next = 15;
            break;
          }

          _context.next = 12;
          return nextNode;

        case 12:
          nextNode = options.reverse ? walker.previousNode() : walker.nextNode();
          _context.next = 9;
          break;

        case 15:
          if (!(options.reverse && acceptFn(container, strict))) {
            _context.next = 18;
            break;
          }

          _context.next = 18;
          return container;

        case 18:
          return _context.abrupt("return", undefined);

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function getFocusableChild(container) {
  var lastChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return iterateFocusableElements(container, {
    reverse: lastChild,
    strict: true,
    onlyTabbable: true
  }).next().value;
}
export function isFocusable(elem) {
  var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var disabledAttrInert = ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA', 'OPTGROUP', 'OPTION', 'FIELDSET'].includes(elem.tagName) && elem.disabled;
  var hiddenInert = elem.hidden;
  var hiddenInputInert = elem instanceof HTMLInputElement && elem.type === 'hidden';
  var sentinelInert = elem.classList.contains('sentinel');

  if (disabledAttrInert || hiddenInert || hiddenInputInert || sentinelInert) {
    return false;
  }

  if (strict) {
    var sizeInert = elem.offsetWidth === 0 || elem.offsetHeight === 0;
    var visibilityInert = ['hidden', 'collapse'].includes(getComputedStyle(elem).visibility);
    var clientRectsInert = elem.getClientRects().length === 0;

    if (sizeInert || visibilityInert || clientRectsInert) {
      return false;
    }
  }

  if (elem.getAttribute('tabindex') != null) {
    return true;
  }

  if (elem instanceof HTMLAnchorElement && elem.getAttribute('href') == null) {
    return false;
  }

  return elem.tabIndex !== -1;
}
export function isTabbable(elem) {
  var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return isFocusable(elem, strict) && elem.getAttribute('tabindex') !== '-1';
}